import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api, type ReportRecord, type ReportRow } from '../api';

export function ReportDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [report, setReport] = useState<ReportRow | null>(null);
  const [records, setRecords] = useState<ReportRecord[]>([]);

  useEffect(() => {
    if (!id) return;
    api.reportDetail(id).then((d) => {
      setReport(d.report);
      setRecords(d.records);
    });
  }, [id]);

  if (!report) return <p className="muted">Loading…</p>;

  return (
    <>
      <div className="card">
        <h2>{report.domain}</h2>
        <dl className="kv">
          <dt>Provider</dt><dd>{report.org_name || '—'} ({report.org_email || '—'})</dd>
          <dt>Report ID</dt><dd>{report.report_id}</dd>
          <dt>Window</dt>
          <dd>{new Date(report.date_begin).toUTCString()} → {new Date(report.date_end).toUTCString()}</dd>
          <dt>Policy</dt><dd>p={report.policy_p ?? '—'}, pct={report.policy_pct ?? 100}</dd>
        </dl>
      </div>
      <div className="card">
        <h2>Records ({records.length})</h2>
        <table>
          <thead>
            <tr>
              <th>Source IP</th>
              <th>Header-From</th>
              <th>Count</th>
              <th>Disposition</th>
              <th>DKIM aligned</th>
              <th>SPF aligned</th>
            </tr>
          </thead>
          <tbody>
            {records.map((r) => (
              <tr key={r.id}>
                <td><Link to={`/source/${encodeURIComponent(r.source_ip)}`}>{r.source_ip}</Link></td>
                <td>{r.header_from ?? '—'}</td>
                <td>{r.count}</td>
                <td>{r.disposition ?? '—'}</td>
                <td>{r.dkim_aligned == null ? '—' : r.dkim_aligned ? '✓' : '✗'}</td>
                <td>{r.spf_aligned == null ? '—' : r.spf_aligned ? '✓' : '✗'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
